import { FiMoon, FiSun } from 'react-icons/fi';

import { useTheme } from '../../hooks/theme';

import Container from './styles';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro';

  return (
    <Container
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      aria-pressed={isDark}
      title={label}
    >
      {isDark ? <FiSun size={19} /> : <FiMoon size={19} />}
    </Container>
  );
};

export default ThemeToggle;
